
import * as React from "react"

const BREAKPOINTS = {
  xs: 475,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
} as const

type BreakpointKey = keyof typeof BREAKPOINTS
type ScreenSize = BreakpointKey | 'xs'

export function useScreenSize() {
  const [screenSize, setScreenSize] = React.useState<ScreenSize>('lg')
  const [width, setWidth] = React.useState<number>(1024)

  React.useEffect(() => {
    const updateSize = () => {
      const currentWidth = window.innerWidth
      setWidth(currentWidth)
      
      if (currentWidth < BREAKPOINTS.xs) {
        setScreenSize('xs')
      } else if (currentWidth < BREAKPOINTS.sm) {
        setScreenSize('sm')
      } else if (currentWidth < BREAKPOINTS.md) {
        setScreenSize('md')
      } else if (currentWidth < BREAKPOINTS.lg) {
        setScreenSize('lg')
      } else if (currentWidth < BREAKPOINTS.xl) {
        setScreenSize('xl')
      } else {
        setScreenSize('2xl')
      }
    }

    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  const isMobile = width < BREAKPOINTS.lg
  const isTablet = width >= BREAKPOINTS.md && width < BREAKPOINTS.lg
  const isSmallPhone = width < BREAKPOINTS.xs
  const isLargePhone = width >= BREAKPOINTS.xs && width < BREAKPOINTS.md

  return {
    screenSize,
    width,
    isMobile,
    isTablet,
    isSmallPhone,
    isLargePhone,
    breakpoints: BREAKPOINTS
  }
}
